import { client } from './helpCenter/client.gen';

export const useHelpCenterClient = () => {
  const runtimeApiUrl = import.meta.env.VITE_RUNTIME_API_URL as string | undefined;
  const { baseUrl } = client.getConfig();

  if (runtimeApiUrl && baseUrl !== runtimeApiUrl) {
    client.setConfig({ baseUrl: runtimeApiUrl });
  } else if (!runtimeApiUrl) {
    client.setConfig({ baseUrl: '' });
  }

  return client;
};
